import { useState } from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
 
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import {
  MdAdd,
  MdDelete,
  MdClose,
  MdSearch,
} from "react-icons/md";
import * as XLSX from "xlsx";
import InputAdornment from "@mui/material/InputAdornment";

const tabsData = [
  "OFAC",
  "PEP",
  "UK sanctions",
  "NON SDN",
  "Grey List",
  "White List",
];

const scenarios = ["Bad_data", "Run together"];

const fileTypes = [
  "All",
  "Bad_data",
  "Run together",
  "Aliases",
  "Initial reference",
  "Abbreviations",
  "Missing words",
  "word_list",
  "Name swap",
  "Nick name reference",
  "Symbolic"
];

const previewTableData = [
  {
    id: 0,
    col1: "BANKSESSXXXX",
    col2: "I103BANKNO2XXXXN",
    col3: "SEPA, MNO987123654",
    col4: "",
    col20: "REF987123654",
    col23B: "CRED",
    col32A: "240303SEK3000",
    col50A: "/9871236540 OLIVER ERICSON",
    col57A: "BANKNO2X",
    col59: "/5566778899 HENRY JOHNSTON",
    col70: "HOUSE RENT",
    col71A: "SHA",
    col72: "/INS/SAME DAY PROCESSING",
  },
  {
    id: 1,
    col1: "BANKFIHHXXXX",
    col2: "I103BANKDKKKXXXXN",
    col3: "SEPA, PQR456789123",
    col4: "",
    col20: "REF456789123",
    col23B: "CRED",
    col32A: "240303SEK5000",
    col50A: "/4567891230 EMMA WILSON",
    col57A: "BANKDKKKX",
    col59: "/1122334455 JAMES BROWN",
    col70: "CAR LOAN",
    col71A: "SHA",
    col72: "/INS/SAME DAY PROCESSING",
  },
  {
    id: 2,
    col1: "BANKPTPLXXXX",
    col2: "I103BANKGRXXXXXXN",
    col3: "SEPA, STU654321987",
    col4: "",
    col20: "REF654321987",
    col23B: "CRED",
    col32A: "240303SEK7000",
    col50A: "/6543219870 LUCAS MARTIN",
    col57A: "BANKGRXXX",
    col59: "/9988776655 SARAH DAVIS",
    col70: "HOME RENOVATION",
    col71A: "SHA",
    col72: "/INS/SAME DAY PROCESSING",
  },
  {
    id: 3,
    col1: "BANKESPBXXXX",
    col2: "I103BANKITRRXXXXN",
    col3: "SEPA, VWX321654987",
    col4: "",
    col20: "REF321654987",
    col23B: "CRED",
    col32A: "240303SEK4000",
    col50A: "/3216549870 SOPHIA LEE",
    col57A: "BANKITRRX",
    col59: "/4455667788 MICHAEL WHITE",
    col70: "EDUCATION",
    col71A: "SHA",
    col72: "/INS/SAME DAY PROCESSING",
  },
  {
    id: 4,
    col1: "BANKDEFFXXXX",
    col2: "I103BANKFRXXXXXXN",
    col3: "SEPA, YZA987654321",
    col4: "",
    col20: "REF987654321",
    col23B: "CRED",
    col32A: "240303SEK6000",
    col50A: "/9876543210 THOMAS CLARK",
    col57A: "BANKFRXXX",
    col59: "/6677889900 LUCY ADAMS",
    col70: "BUSINESS EXPENSE",
    col71A: "SHA",
    col72: "/INS/SAME DAY PROCESSING",
  },
];


const FileNameOptionsByType = {
  "OFAC": [
    "ofac-23-04-2025-120000_processed.pdf",
    "ofac-22-04-2025-130000_processed.pdf",
    "ofac-21-04-2025-140000_processed.pdf",
    "ofac-20-04-2025-150000_processed.pdf",
    "ofac-19-04-2025-160000_processed.pdf",
    "ofac-18-04-2025-170000_processed.pdf",
    "ofac-17-04-2025-180000_processed.pdf",
    "ofac-16-04-2025-190000_processed.pdf",
    "ofac-15-04-2025-200000_processed.pdf",
    "ofac-14-04-2025-210000_processed.pdf"
  ],
  "PEP": [
    "pep-23-04-2025-120000_processed.pdf",
    "pep-22-04-2025-130000_processed.pdf",
    "pep-21-04-2025-140000_processed.pdf",
    "pep-20-04-2025-150000_processed.pdf",
    "pep-19-04-2025-160000_processed.pdf",
    "pep-18-04-2025-170000_processed.pdf",
    "pep-17-04-2025-180000_processed.pdf",
    "pep-16-04-2025-190000_processed.pdf",
    "pep-15-04-2025-200000_processed.pdf",
    "pep-14-04-2025-210000_processed.pdf"
  ],
  "UK sanctions": [
    "uk-sanctions-23-04-2025-120000_processed.pdf",
    "uk-sanctions-22-04-2025-130000_processed.pdf",
    "uk-sanctions-21-04-2025-140000_processed.pdf",
    "uk-sanctions-20-04-2025-150000_processed.pdf",
    "uk-sanctions-19-04-2025-160000_processed.pdf",
    "uk-sanctions-18-04-2025-170000_processed.pdf",
    "uk-sanctions-17-04-2025-180000_processed.pdf",
    "uk-sanctions-16-04-2025-190000_processed.pdf",
    "uk-sanctions-15-04-2025-200000_processed.pdf",
    "uk-sanctions-14-04-2025-210000_processed.pdf"
  ],
  "NON SDN": [
    "non-sdn-23-04-2025-120000_processed.pdf",
    "non-sdn-22-04-2025-130000_processed.pdf",
    "non-sdn-21-04-2025-140000_processed.pdf",
    "non-sdn-20-04-2025-150000_processed.pdf",
    "non-sdn-19-04-2025-160000_processed.pdf",
    "non-sdn-18-04-2025-170000_processed.pdf",
    "non-sdn-17-04-2025-180000_processed.pdf",
    "non-sdn-16-04-2025-190000_processed.pdf",
    "non-sdn-15-04-2025-200000_processed.pdf",
    "non-sdn-14-04-2025-210000_processed.pdf"
  ],
  "Grey List": [
    "grey-list-23-04-2025-120000_processed.pdf",
    "grey-list-22-04-2025-130000_processed.pdf",
    "grey-list-21-04-2025-140000_processed.pdf",
    "grey-list-20-04-2025-150000_processed.pdf",
    "grey-list-19-04-2025-160000_processed.pdf",
    "grey-list-18-04-2025-170000_processed.pdf",
    "grey-list-17-04-2025-180000_processed.pdf",
    "grey-list-16-04-2025-190000_processed.pdf",
    "grey-list-15-04-2025-200000_processed.pdf",
    "grey-list-14-04-2025-210000_processed.pdf"
  ],
  "White List": [
    "white-list-23-04-2025-120000_processed.pdf",
    "white-list-22-04-2025-130000_processed.pdf",
    "white-list-21-04-2025-140000_processed.pdf",
    "white-list-20-04-2025-150000_processed.pdf",
    "white-list-19-04-2025-160000_processed.pdf",
    "white-list-18-04-2025-170000_processed.pdf",
    "white-list-17-04-2025-180000_processed.pdf",
    "white-list-16-04-2025-190000_processed.pdf",
    "white-list-15-04-2025-200000_processed.pdf",
    "white-list-14-04-2025-210000_processed.pdf"
  ]
};

const defaultRows = [
  {
    id: 1,
    fileName: ["ofac-23-04-2025-120000_processed.pdf"],
    scenario: ["Bad_data"],
    startRange: "1",
    endRange: "10",
  },
  {
    id: 2,
    fileName: ["ofac-23-04-2025-120000_processed.pdf"],
    scenario: ["Run together"],
    startRange: "11",
    endRange: "20",
  },
  {
    id: 3,
    fileName: ["ofac-23-04-2025-120000_processed.pdf"],
    scenario: ["Aliases"],
    startRange: "21",
    endRange: "30",
  },
];

const DataSelectionNew4 = () => {
  const [summaryModal, setSummaryModal] = useState(false);
  const [rows, setRows] = useState(defaultRows);
  const [showTable, setShowTable] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [previewFileName, setPreviewFileName] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  // Add modal states
  const [modalCurrentPage, setModalCurrentPage] = useState(1);
  const [summaryData, setSummaryData] = useState([
    {
      id: 1,
      fileName: "ofac-2024-03-15-120000_processed",
      scenario: "Bad_data",
      count: 100,
    },
    {
      id: 2,
      fileName: "pep-2024-03-15-130000_processed",
      scenario: "Run together",
      count: 150,
    },
    {
      id: 3,
      fileName: "uk-sanctions-2024-03-15-140000_processed",
      scenario: "Aliases",
      count: 200,
    },
  ]);

  // Get file name options based on selected file type
  const getFileNameOptions = (fileType) => {
    return fileType ? FileNameOptionsByType[fileType] || [] : [];
  };

  const handleFileTypeChange = (id, value) => {
    setRows(
      rows.map((row) => {
        if (row.id === id) {
          return { ...row, fileType: value, fileName: [] };
        }
        return row;
      })
    );
  };

  const handleAddRow = () => {
    const newId = rows.length > 0 ? Math.max(...rows.map((r) => r.id)) + 1 : 1;
    setRows([...rows, { id: newId, fileName: ["ofac-23-04-2025-120000_processed.pdf"], scenario: [] }]);
  };

  const handleDeleteRow = (id) => {
    setRows(prev => prev.filter(row => row.id !== id));
  };

  const handleChange = (id, field, value) => {
    if (field === "scenario") {
      const currentRow = rows.find((row) => row.id === id);
      const currentValues = currentRow.scenario;
      
      if (value.includes("all")) {
        if (currentValues.includes("all")) {
          setRows(
            rows.map((row) => (row.id === id ? { ...row, scenario: [] } : row))
          );
        } else {
          setRows(
            rows.map((row) =>
              row.id === id ? { ...row, scenario: ["all", ...scenarios] } : row
            )
          );
        }
      } else {
        const updatedScenario = value.filter((item) => item !== "all");
        const allIndividualSelected = scenarios.every((option) =>
          updatedScenario.includes(option)
        );

        if (allIndividualSelected) {
          setRows(
            rows.map((row) =>
              row.id === id ? { ...row, scenario: ["all", ...scenarios] } : row
            )
          );
        } else {
          setRows(
            rows.map((row) =>
              row.id === id ? { ...row, scenario: updatedScenario } : row
            )
          );
        }
      }
    } else {
      setRows(
        rows.map((row) => (row.id === id ? { ...row, [field]: value } : row))
      );
    }
  };

  const handleNextClick = () => {
    setShowTable(true);
  };

  const handleSearchTermChange = (value) => {
    setSearchTerm(value);
  };

  const handlePreviewFileNameChange = (value) => {
    setPreviewFileName(value);
  };

  // Pagination functions
  const handleFirstPage = () => {
    setCurrentPage(1);
  };

  const handleLastPage = () => {
    setCurrentPage(Math.ceil(previewTableData.length / itemsPerPage));
  };

  const handlePrevPage = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage((prev) =>
      Math.min(prev + 1, Math.ceil(previewTableData.length / itemsPerPage))
    );
  };

  const handleSelectAll = (id, field, options) => {
    const currentRow = rows.find((row) => row.id === id);
    const currentValues = currentRow[field];
    const allSelected = currentValues.length === options.length;

    if (allSelected) {
      setRows(
        rows.map((row) => (row.id === id ? { ...row, [field]: [] } : row))
      );
    } else {
      if (field === "scenario") {
        setRows(
          rows.map((row) =>
            row.id === id ? { ...row, scenario: ["all", ...scenarios] } : row
          )
        );
      } else if (field === "fileName") {
        setRows(
          rows.map((row) =>
            row.id === id ? { ...row, fileName: ["all", ...options] } : row
          )
        );
      }
    }
  };

  // Get current items for pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = previewTableData.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  const filteredFileNames = getFileNameOptions(rows[0]?.fileType).filter((name) =>
    name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSummaryModal = () => {
    setSummaryModal(!summaryModal);
  };

  // Add modal pagination functions
  const handleModalFirstPage = () => {
    setModalCurrentPage(1);
  };

  const handleModalLastPage = () => {
    setModalCurrentPage(Math.ceil(summaryData.length / itemsPerPage));
  };

  const handleModalPrevPage = () => {
    setModalCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handleModalNextPage = () => {
    setModalCurrentPage((prev) =>
      Math.min(prev + 1, Math.ceil(summaryData.length / itemsPerPage))
    );
  };

  // Get current items for modal pagination
  const modalIndexOfLastItem = modalCurrentPage * itemsPerPage;
  const modalIndexOfFirstItem = modalIndexOfLastItem - itemsPerPage;
  const modalCurrentItems = summaryData.slice(
    modalIndexOfFirstItem,
    modalIndexOfLastItem
  );

  // Add state for table file type
  const [tableFileType, setTableFileType] = useState("");

  const [modalOpen, setModalOpen] = useState(false);
  const [modalFileName] = useState(["ofac-23-04-2025-120000_processed.pdf"]);
  const [modalScenario, setModalScenario] = useState([]);
  const [modalStartRange, setModalStartRange] = useState("");
  const [modalEndRange, setModalEndRange] = useState("");
  const [scenarioSearch, setScenarioSearch] = useState("");

  const handleOpenModal = () => {
    setModalScenario([]);
    setModalStartRange("");
    setModalEndRange("");
    setScenarioSearch("");
    setModalOpen(true);
  };

  const handleCloseModal = () => setModalOpen(false);

  const handleSaveSelection = () => {
    if (modalScenario.length === 0) return;
    setRows(prev => [
      ...prev,
      {
        id: Date.now(),
        fileName: ["ofac-23-04-2025-120000_processed.pdf"],
        scenario: modalScenario,
        startRange: modalStartRange,
        endRange: modalEndRange,
      },
    ]);
    setModalOpen(false);
  };

  return (
    <div className="efficiency-page">
      <div className="page-container">
        <div className="row justify-content-between">
          <div className="col-12 col-md-4">
            <h5 className="mb-4">Data Selection</h5>
          </div>
          <div className="col-12 col-md-4 text-end">
            <button className="anchor-button" onClick={handleSummaryModal}>
              View Summary
            </button>
          </div>
        </div>

        {summaryModal && (
          <div className="modal-overlay">
            <div className="modal-container">
              <div className="row justify-content-between align-items-center mb-3">
                <div className="col-auto">
                  <h5 className="mt-4">Summary</h5>
                </div>
                <div className="col-auto">
                  <IconButton onClick={handleSummaryModal} size="small">
                    <MdClose />
                  </IconButton>
                </div>
              </div>
              <div className="table-responsive">
                <table className="table table-bordered table-striped">
                  <thead className="table-dark">
                    <tr>
                      <th>#</th>
                      <th>File Name</th>
                      <th>Scenario</th>
                      <th>Count</th>
                    </tr>
                  </thead>
                  <tbody>
                    {modalCurrentItems.map((row, index) => (
                      <tr key={row.id}>
                        <td>
                          {modalIndexOfFirstItem + index + 1}
                        </td>
                        <td>{row.fileName}</td>
                        <td>{row.scenario}</td>
                        <td>{row.count}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="d-flex justify-content-end mt-3">
                <div className="pagination">
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={handleModalFirstPage}
                    disabled={modalCurrentPage === 1}
                    className="me-2"
                  >
                    First
                  </Button>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={handleModalPrevPage}
                    disabled={modalCurrentPage === 1}
                    className="me-2"
                  >
                    Prev
                  </Button>
                  <span className="mx-2 align-self-center">
                    Page {modalCurrentPage} of{" "}
                    {Math.ceil(summaryData.length / itemsPerPage)}
                  </span>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={handleModalNextPage}
                    disabled={
                      modalCurrentPage ===
                      Math.ceil(summaryData.length / itemsPerPage)
                    }
                    className="me-2"
                  >
                    Next
                  </Button>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={handleModalLastPage}
                    disabled={
                      modalCurrentPage ===
                      Math.ceil(summaryData.length / itemsPerPage)
                    }
                  >
                    Last
                  </Button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* <div className="card">
          <div className="card-body"> */}
            <div className="d-flex justify-content-end mb-3">
              <Button
                variant="contained"
                color="primary"
                onClick={handleOpenModal}
                startIcon={<MdAdd />}
                sx={{
                  backgroundColor: 'var(--theme-color)',
                  color: '#fff',
                  '&:hover': {
                    backgroundColor: 'var(--theme-color)', 
                    opacity: 0.9, 
                  },
                }}
              >
                Add New Selection
              </Button>
            </div>
            <div>
              <table size="small" className="table table-bordered table-striped">
                <thead className="table-dark">
                  <tr>
                    <th>File Name</th>
                    <th>Scenario</th>
                    <th>Record Count</th>
                    {/* <th>End Range</th> */}
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((row) => (
                    <tr key={row.id}>
                      <td>{Array.isArray(row.fileName) ? row.fileName.join(", ") : row.fileName}</td>
                      <td>{Array.isArray(row.scenario) ? row.scenario.join(", ") : row.scenario}</td>
                      <td>{row.startRange}</td>
                      {/* <td>{row.endRange}</td> */}
                      <td>
                        <IconButton color="error" onClick={() => handleDeleteRow(row.id)}>
                          <MdDelete />
                        </IconButton>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          {/* </div>
        </div> */}

        <div className="row justify-content-center mt-3">
          <div className="col-auto">
            <Button
              variant="contained"
              color="primary"
              onClick={handleNextClick}
              sx={{
                backgroundColor: 'var(--theme-color)',
                color: '#fff',
                '&:hover': {
                  backgroundColor: 'var(--theme-color)', 
                  opacity: 0.9, 
                },
              }}
            >
              Apply
            </Button>
          </div>
        </div>

        {showTable && (
          <div className="card mt-4">
            <div className="card-body">
              <div className="row justify-content-between align-items-center mb-3">
                <div className="col-6">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      const table = document.getElementById("fileTable");
                      if (table) {
                        const ws = XLSX.utils.table_to_sheet(table);
                        const wb = XLSX.utils.book_new();
                        XLSX.utils.book_append_sheet(wb, ws, "Table Data");
                        XLSX.writeFile(wb, "table_export.xlsx");
                      }
                    }}
                  >
                    Download
                  </Button>
                </div>
                <div className="col-md-6">
                  <div className="row justify-content-end">
                    <div className="col-md-6">
                      <FormControl fullWidth size="small">
                        <InputLabel>Scenarios</InputLabel>
                        <Select
                          value={tableFileType}
                          onChange={(e) => {
                            setTableFileType(e.target.value);
                            // handlePreviewFileNameChange("");
                          }}
                          label="File Type"
                          sx={{ minWidth: 200 }}
                        >
                          {fileTypes.map((type) => (
                            <MenuItem key={type} value={type}>
                              {type}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                    
                  </div>
                </div>
              </div>

              <div className="table-responsive">
                <table
                  id="fileTable"
                  className="table table-bordered table-striped"
                >
                  <thead className="table-dark">
                    <tr>
                      <th>#</th>
                      <th>1:</th>
                      <th>2:</th>
                      <th>3:</th>
                      <th>4:</th>
                      <th>:20:</th>
                      <th>:23B:</th>
                      <th>:32A:</th>
                      <th>:50A:</th>
                      <th>:57A:</th>
                      <th>:59:</th>
                      <th>:70:</th>
                      <th>:71A:</th>
                      <th>:72:</th>
                    </tr>
                  </thead>
                  <tbody>
                    {previewTableData
                        
                        .map((row, index) => (
                      <tr key={row.id}>
                        <td>{indexOfFirstItem + index + 1}</td>
                        <td>{row.col1}</td>
                        <td>{row.col2}</td>
                        <td>{row.col3}</td>
                        <td>{row.col4}</td>
                        <td>{row.col20}</td>
                        <td>{row.col23B}</td>
                        <td>{row.col32A}</td>
                        <td>{row.col50A}</td>
                        <td>{row.col57A}</td>
                        <td>{row.col59}</td>
                        <td>{row.col70}</td>
                        <td>{row.col71A}</td>
                        <td>{row.col72}</td>
                      </tr>
                    ))}
                   
                  </tbody>
                </table>
              </div>

              <div className="d-flex justify-content-end mt-3">
                <div className="pagination">
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={handleFirstPage}
                    disabled={currentPage === 1}
                    className="me-2"
                  >
                    First
                  </Button>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={handlePrevPage}
                    disabled={currentPage === 1}
                    className="me-2"
                  >
                    Prev
                  </Button>
                  <span className="mx-2 align-self-center">
                    Page {currentPage} of{" "}
                    {Math.ceil(previewTableData.length / itemsPerPage)}
                  </span>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={handleNextPage}
                    disabled={
                      currentPage ===
                      Math.ceil(previewTableData.length / itemsPerPage)
                    }
                    className="me-2"
                  >
                    Next
                  </Button>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={handleLastPage}
                    disabled={
                      currentPage ===
                      Math.ceil(previewTableData.length / itemsPerPage)
                    }
                  >
                    Last
                  </Button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Modal for Add New Selection */}
      <Dialog open={modalOpen} onClose={handleCloseModal} maxWidth="xs" fullWidth>
        <DialogTitle sx={{ fontWeight: 600 }}>Add New Selection</DialogTitle>
        <DialogContent>
          <div style={{ marginBottom: 16 }}>
            <div style={{ fontWeight: 500, marginBottom: 4 }}>File Name</div>
            <FormControl fullWidth size="small">
              <TextField
                value="ofac-23-04-2025-120000_processed.pdf"
                disabled
                fullWidth
                size="small"
              />
            </FormControl>
          </div>
          <div style={{ marginBottom: 16 }}>
            <div style={{ fontWeight: 500, marginBottom: 4 }}>Scenario</div>
            <FormControl fullWidth size="small">
              <Select
                multiple
                value={modalScenario}
                onChange={e => {
                  const value = e.target.value;
                  if (value.includes('all')) {
                    if (modalScenario.length === scenarios.length) {
                      setModalScenario([]);
                    } else {
                      setModalScenario(scenarios);
                    }
                  } else {
                    setModalScenario(value);
                  }
                }}
                renderValue={selected => selected.join(", ")}
                displayEmpty
                MenuProps={{ PaperProps: { style: { maxHeight: 300 } } }}
              >
                {/* Search bar for scenarios */}
                <MenuItem disableRipple style={{ cursor: "default" }}>
                  <TextField
                    size="small"
                    placeholder="Search scenarios..."
                    value={scenarioSearch}
                    onChange={e => setScenarioSearch(e.target.value)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <MdSearch />
                        </InputAdornment>
                      ),
                      inputProps: {
                        autoComplete: 'off',
                        style: { imeMode: 'unset' },
                        autoFocus: false,
                        disableAutoFocus: true,
                        disableAutoFocusItem: true,
                      },
                      tabIndex: 0,
                    }}
                    fullWidth
                    autoFocus={false}
                  />
                </MenuItem>
                <MenuItem value="all">
                  <Checkbox
                    checked={modalScenario.length === scenarios.length}
                    indeterminate={modalScenario.length > 0 && modalScenario.length < scenarios.length}
                  />
                  <ListItemText primary="Select All" />
                </MenuItem>
                {scenarios.filter(s => s.toLowerCase().includes(scenarioSearch.toLowerCase())).map(s => (
                  <MenuItem key={s} value={s}>
                    <Checkbox checked={modalScenario.indexOf(s) > -1} />
                    <ListItemText primary={s} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div style={{ marginBottom: 16 }}>
            <div style={{ fontWeight: 500, marginBottom: 4 }}>Record Count</div>
            <TextField
              fullWidth
              size="small"
              value={modalStartRange}
              onChange={e => setModalStartRange(e.target.value)}
              placeholder="Record Count"
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} variant="outlined" className="btn btn-cancel">Cancel</Button>
          <Button onClick={handleSaveSelection} variant="contained" color="primary" disabled={modalScenario.length === 0}>
            Save Selection
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DataSelectionNew4;
